export default "__VITE_ASSET__rRRL3jZQ__"